import React from 'react';
import './faculty-ui.css';

export default function Button({ variant = 'primary', disabled = false, onClick, children, type = 'button', style }) {
  return (
    <button type={type} className={`ui-btn ${variant}`} disabled={disabled} onClick={onClick} style={style}>
      {children}
    </button>
  );
}
